export enum FEATURE_PERMISSIONS {
  ADS_FREE = "ads_free",
  DOWNLOADS = "downloads",
  DARK_MODE = "dark_mode",
  FONT_SIZE = "font_size",
  SHARE = "share",
}
